import { useEffect } from 'react'
import { useApolloClient } from '@apollo/client/react'
import { identifyUser } from 'lib/tracking/segment'
import { useUserTraits } from '../../../../hooks/useUserTraits/useUserTraits'
import { SegmentIdentityTrackingHook_intercomUserJwtDocument } from './useSegmentIdentityTracking.graphql'

export const useSegmentIdentityTracking = (profileId: string) => {
  const traits = useUserTraits()
  const client = useApolloClient()

  // The Intercom JWT expires within the hour while a tab can stay open for days, so each identify
  // fetches a fresh one instead of reusing the cached profile's.
  useEffect(() => {
    if (!profileId) {
      return
    }

    let cancelled = false

    client
      .query({ query: SegmentIdentityTrackingHook_intercomUserJwtDocument, fetchPolicy: 'network-only' })
      .then(({ data }) => data.profile?.intercomUserJwt ?? null)
      .catch(() => null)
      .then((intercomUserJwt) => {
        if (!cancelled) {
          identifyUser({ userId: profileId, traits: traits ?? {}, intercomUserJwt })
        }
      })

    return () => {
      cancelled = true
    }
  }, [client, profileId, traits])
}
